import settingsMnu from '../actions/settingsMenu'
export default [
  settingsMnu
]
